/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueSelectBoxComponent } from './sysque-select-box.component';
import { DxSelectBoxModule, DxTemplateModule } from 'devextreme-angular';

@NgModule({
  declarations: [SysqueSelectBoxComponent],
  imports: [CommonModule, DxSelectBoxModule, DxTemplateModule],
  exports: [SysqueSelectBoxComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueSelectBoxModule {}
